import _extends from "@babel/runtime/helpers/extends";
import { Button, Empty, Table } from "antd";
import { observer } from "mobx-react";
import { invokeGtag } from "../../../../others";
import { IMPREZA_BUTTON_PROPS, __ } from "../../../../utils";
const {
  Column,
  ColumnGroup
} = Table;
const AccountInstallationsTable = observer(_ref => {
  let {
    records
  } = _ref;
  return /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    locale: {
      emptyText: /*#__PURE__*/React.createElement(Empty, {
        description: __("No data")
      })
    },
    pagination: false,
    dataSource: records,
    rowKey: row => row.data.productName,
    size: "small"
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("Product"),
    dataIndex: "product",
    key: "product",
    render: (_, _ref2) => {
      let {
        data: {
          productName
        }
      } = _ref2;
      return productName;
    }
  }), /*#__PURE__*/React.createElement(ColumnGroup, {
    title: __("License keys created for")
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("Production"),
    dataIndex: "installationsProduction",
    key: "installationsProduction",
    render: (_, _ref3) => {
      let {
        data: {
          maxInstallationsProduction,
          installationsProduction
        }
      } = _ref3;
      return `${installationsProduction} / ${maxInstallationsProduction}`;
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Development"),
    dataIndex: "installationDevelopment",
    key: "installationDevelopment",
    render: (_, _ref4) => {
      let {
        data: {
          maxInstallationsDevelopment,
          installationDevelopment
        }
      } = _ref4;
      return `${installationDevelopment} / ${maxInstallationsDevelopment}`;
    }
  })), /*#__PURE__*/React.createElement(Column, {
    title: __("Download"),
    dataIndex: "actions",
    key: "actions",
    align: "right",
    render: (_, _ref5) => {
      let {
        data: {
          productName,
          downloadUrl
        }
      } = _ref5;
      return !!downloadUrl && /*#__PURE__*/React.createElement(Button, _extends({
        type: "primary",
        onClick: () => {
          invokeGtag(gtag => gtag("event", "download_product", {
            event_category: "ecommerce",
            event_label: "Download product",
            value: productName
          }));
          window.location.href = downloadUrl;
        }
      }, IMPREZA_BUTTON_PROPS), __("Download"));
    }
  }));
});
export { AccountInstallationsTable };